export default __webpack_public_path__ + "assets/images/6c7693c1cfbc5638a6303cac0e36ce5f.svg";